// extracted by mini-css-extract-plugin
export default {"menu":"ListItemMenu_menu__XXS1K","menu-expanded":"ListItemMenu_menu-expanded__ozfs3"};